export default __webpack_public_path__ + "assets/lesotho-flag.png";